module.exports = __webpack_public_path__ + "static/img/offshelf.989fb6fd.png";